import { render, staticRenderFns } from "./ForbiddenIngredientWarningModal.vue?vue&type=template&id=130e229c"
import script from "./ForbiddenIngredientWarningModal.vue?vue&type=script&lang=js"
export * from "./ForbiddenIngredientWarningModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports